import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'getPastDueBannerText'
})

export class GetPastDueBannerText implements PipeTransform{
    transform(value:number, args?:any):any{
        let cntText;
        if(value > 100) cntText = "100+";
        else cntText = value.toString();

        return `${cntText} cases are overdue`;
    }
    getPastDueBannerText(count:number):string{
        let cntText;
        if(count > 100) cntText = "100+";
        else cntText = count.toString();

        return `${cntText} cases are overdue`;
    }
}